import { render } from "./ForgetPassword.vue?vue&type=template&id=e37a2b90&scoped=true"
import script from "./ForgetPassword.vue?vue&type=script&lang=ts"
export * from "./ForgetPassword.vue?vue&type=script&lang=ts"

import "./ForgetPassword.vue?vue&type=style&index=0&id=e37a2b90&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e37a2b90"

export default script